import {createStore, combineReducers, applyMiddleware, compose} from 'redux';
import createSagaMiddleware from 'redux-saga';
import {all} from 'redux-saga/effects';

/* Helpers */
import {startSdkHelpers} from '../helpers/sdk-helpers.js';
/* Sagas */
import userSaga from './user/user-saga';
import dashboardSaga from './dashboard/dashboard-saga';
import tooltipsSaga from './tooltips/saga';
/* Reducers */
import testReducer from '../pages/test/test-reducer';
import userReducer from './user/user-reducer';
import dashboardReducer from './dashboard/dashboard-reducer';
import tooltipsReducer from './tooltips/reducer';

const allReducers = combineReducers({
  testReducer,
  userReducer,
  dashboardReducer,
  tooltipsReducer,
});

function* allSagas() {
  yield all([userSaga(), dashboardSaga(), tooltipsSaga()]);
}

let store = null;
let sagas = null;
const sagaMiddleware = createSagaMiddleware();

let enhancer = applyMiddleware(sagaMiddleware);
if (process.env.NODE_ENV === 'development') {
  /* eslint-disable no-underscore-dangle */
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  enhancer = composeEnhancers(enhancer);
}

export const initStore = () => {
  store = createStore(allReducers, undefined, enhancer);

  sagas = sagaMiddleware.run(allSagas);

  startSdkHelpers(store);

  return store;
};

export const destroyStore = () => {
  sagas.cancel();

  store.dispatch({
    type: 'DESTROY',
  });
};
